module.exports = __webpack_public_path__ + "img/rjdb@2x.f76c264a.png";